import React, { useState, useMemo } from 'react';
import {
  Table, Tag, Space, Button, Card, Form, Input, Select,
  Typography, Modal, Checkbox, Drawer, message,
  Tooltip, Row, Col, DatePicker
} from 'antd';
import {
  SearchOutlined, ReloadOutlined,
  SettingOutlined, SwapOutlined, WarningFilled,
  InboxOutlined, FolderOpenOutlined, UndoOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

const { Title, Text } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;

// ══════════════════════════════════════════════
//  Mock 数据
//  TODO: 联调时替换为接口数据
// ══════════════════════════════════════════════

const MOCK_CUSTOMERS = [
  { key: '1', enterpriseId: 'test-ent-001', enterpriseName: 'test-深圳智创科技有限公司', aliasName: '深圳智创',
    contactPerson: '张三', contactPhone: '13800001111', email: 'zhang@test-smart.com',
    authStatus: '已认证',
    background: '专注于智能家居领域的方案商，团队约50人',
    responsibleUserId: 'user-01', responsibleName: '李客服', responsibleAccount: 'lifuwu',
    weight: 95, status: 'active', hasRisk: 1,
    currentIssues: 'SDK对接过程中发现设备端编码格式不兼容，需要升级固件',
    currentRequirements: '希望平台提供批量设备管理API',
    pendingTasks: '下周五前完成固件升级测试', servicePlan: '每周一跟进SDK对接进度，周三技术会议同步',
    riskNotes: '客户项目上线日期临近，SDK问题可能影响交付',
    tags: { serviceContent: ['设备SDK对接', '平台API对接'], customerCategory: ['私有定制'], capability: ['方案商', '应用服务商'], customerTag: ['01战略客户'] },
    archivedAt: '', updatedAt: '2026-07-23 09:30', createdAt: '2026-06-01 10:00', createdBy: '王主管',
    lastLoginAt: '2026-09-13 08:20',
  },
  { key: '2', enterpriseId: 'test-ent-002', enterpriseName: 'test-广州迅捷科技有限公司', aliasName: '广州迅捷',
    contactPerson: '李四', contactPhone: '13800002222', email: 'lisi@test-xunjie.com',
    authStatus: '已认证',
    background: '设备制造商，主要生产4G摄像头',
    responsibleUserId: 'user-02', responsibleName: '王客服', responsibleAccount: 'wangyuan',
    weight: 80, status: 'active',
    currentIssues: 'License采购流程不熟悉，需要培训', currentRequirements: '', pendingTasks: '',
    servicePlan: '已安排周三下午进行培训', riskNotes: '',
    tags: { serviceContent: ['App OEM定制'], customerCategory: ['公版定制'], capability: ['工厂'], customerTag: ['02大客户'] },
    archivedAt: '', updatedAt: '2026-07-22 16:20', createdAt: '2026-05-15 14:00', createdBy: '王主管',
    lastLoginAt: '2026-09-08 19:40',
  },
  { key: '3', enterpriseId: 'test-ent-003', enterpriseName: 'test-上海云联科技有限公司', aliasName: '上海云联',
    contactPerson: '王五', contactPhone: '13800003333', email: 'wangwu@test-yunlian.com',
    authStatus: '已认证',
    background: '应用服务商，主要做SaaS定制',
    responsibleUserId: 'user-01', responsibleName: '李客服', responsibleAccount: 'lifuwu',
    weight: 70, status: 'active',
    currentIssues: '云平台私有化部署环境准备中', currentRequirements: '需要私有化部署文档和技术支持',
    pendingTasks: '部署环境确认', servicePlan: '跟进部署进度，协调技术支持', riskNotes: '',
    tags: { serviceContent: ['云平台私有化部署', '行业SaaS定制'], customerCategory: ['私有定制'], capability: ['应用服务商'], customerTag: ['02大客户'] },
    archivedAt: '', updatedAt: '2026-07-21 11:00', createdAt: '2026-04-20 09:00', createdBy: '赵主管',
    lastLoginAt: '2026-09-02 10:15',
  },
  { key: '4', enterpriseId: 'test-ent-004', enterpriseName: 'test-成都天视科技有限公司', aliasName: '成都天视',
    contactPerson: '赵六', contactPhone: '13800004444', email: 'zhaoliu@test-tianshi.com',
    authStatus: '已认证', background: '渠道商，代理销售监控设备',
    responsibleUserId: 'user-03', responsibleName: '张客服', responsibleAccount: 'zhangwei',
    weight: 50, status: 'active',
    currentIssues: '', currentRequirements: '希望了解最新的渠道政策', pendingTasks: '',
    servicePlan: '月底前发送最新政策文档', riskNotes: '',
    tags: { serviceContent: ['WEB SDK对接'], customerCategory: ['标准对接'], capability: ['渠道商'], customerTag: ['03中等客户'] },
    archivedAt: '', updatedAt: '2026-07-20 14:00', createdAt: '2026-03-10 11:00', createdBy: '王主管',
    lastLoginAt: '2026-08-10 14:00',
  },
  { key: '5', enterpriseId: 'test-ent-005', enterpriseName: 'test-北京数联科技有限公司', aliasName: '北京数联',
    contactPerson: '孙七', contactPhone: '13800005555', email: 'sunqi@test-shulian.com',
    authStatus: '待审核', background: '新入驻的平台客户，主营AI视觉方案',
    responsibleUserId: 'user-02', responsibleName: '王客服', responsibleAccount: 'wangyuan',
    weight: 60, status: 'active',
    currentIssues: '企业认证审核中', currentRequirements: '尽快完成认证，开始对接',
    pendingTasks: '审核跟进', servicePlan: '审核通过后立即安排对接会议', riskNotes: '',
    tags: { serviceContent: ['AppSDK对接'], customerCategory: ['标准对接'], capability: ['方案商'], customerTag: ['03中等客户'] },
    archivedAt: '', updatedAt: '2026-07-19 10:00', createdAt: '2026-07-18 15:00', createdBy: '王主管',
    lastLoginAt: '2026-09-14 07:00',
  },
  { key: '6', enterpriseId: 'test-ent-006', enterpriseName: 'test-杭州联智科技有限公司', aliasName: '杭州联智',
    contactPerson: '周八', contactPhone: '13800006666', email: 'zhouba@test-lianzhi.com',
    authStatus: '已注销', background: '',
    responsibleUserId: 'user-01', responsibleName: '李客服', responsibleAccount: 'lifuwu',
    weight: 10, status: 'archived',
    currentIssues: '', currentRequirements: '', pendingTasks: '', servicePlan: '', riskNotes: '',
    tags: { serviceContent: ['设备SDK对接'], customerCategory: ['维护型'], capability: ['工厂'], customerTag: ['03中等客户'] },
    archivedAt: '2026-07-15 14:30', updatedAt: '2026-07-15 14:30', createdAt: '2026-01-10 10:00', createdBy: '赵主管',
    lastLoginAt: '2026-06-20 09:00',
  },
];

const MOCK_INTERNAL_USERS = [
  { userId: 'user-01', name: '李客服', account: 'lifuwu' },
  { userId: 'user-02', name: '王客服', account: 'wangyuan' },
  { userId: 'user-03', name: '张客服', account: 'zhangwei' },
  { userId: 'user-04', name: '赵主管', account: 'zhaozg' },
  { userId: 'user-05', name: '王主管', account: 'wangzg' },
];

// 标签池
const TAG_OPTIONS = {
  serviceContent: ['设备SDK对接', 'AppSDK对接', '平台API对接', 'WEB SDK对接', 'App OEM定制', '云平台私有化部署', '行业SaaS定制'],
  customerCategory: ['公版定制', '标准对接', '私有定制', '维护型'],
  customerTag: ['01战略客户', '02大客户', '03中等客户'],
};

// ══════════════════════════════════════════════
//  子组件：批量转移责任人
// ══════════════════════════════════════════════
//  常量
// ══════════════════════════════════════════════
const DEFAULT_COLUMNS = ['weight', 'enterpriseName', 'aliasName', 'serviceContent', 'customerCategory', 'customerTag', 'responsibleName', 'currentIssues', 'risk', 'updatedAt', 'lastLoginAt', 'status', 'actions'];

// 「最后登录」快捷选择：未登录时长下限，起点用足够早的时间表示「不限」
const LAST_LOGIN_PRESETS = [
  { label: '7天未登录', value: [dayjs('2000-01-01 00:00:00'), dayjs().subtract(7, 'day').endOf('day')] },
  { label: '1个月未登录', value: [dayjs('2000-01-01 00:00:00'), dayjs().subtract(1, 'month').endOf('day')] },
  { label: '30天未登录', value: [dayjs('2000-01-01 00:00:00'), dayjs().subtract(30, 'day').endOf('day')] },
];

// ══════════════════════════════════════════════
//  子组件：添加客户弹窗
// ══════════════════════════════════════════════
// ══════════════════════════════════════════════
//  子组件：批量转移责任人
// ══════════════════════════════════════════════
const TransferModal = ({ visible, selectedCount, onCancel, onConfirm }) => {
  const [newUser, setNewUser] = useState(undefined);
  return (
    <Modal title="指定客服" open={visible} onCancel={onCancel} onOk={() => { if (!newUser) { message.warning('请选择新责任人'); return; } onConfirm?.(newUser); }} width={420}>
      <p>已选择：{selectedCount} 个客户</p>
      <Form.Item label="新责任人" required style={{ marginTop: 16 }}>
        <Select placeholder="搜索选择责任人" showSearch value={newUser} onChange={setNewUser} optionFilterProp="children" style={{ width: '100%' }}>
          {MOCK_INTERNAL_USERS.map((u) => <Option key={u.userId} value={u.userId}>{u.name} / {u.account}</Option>)}
        </Select>
      </Form.Item>
    </Modal>
  );
};

// ══════════════════════════════════════════════
//  子组件：列自定义弹窗
// ══════════════════════════════════════════════
const ColumnSettingsModal = ({ visible, selected, onChange, onCancel }) => {
  const allOptions = [
    { key: 'weight', label: '权重' }, { key: 'enterpriseName', label: '企业名称', required: true },
    { key: 'aliasName', label: '企业别名' },
    { key: 'serviceContent', label: '服务内容' }, { key: 'customerCategory', label: '客户分类' },
    { key: 'customerTag', label: '客户标签' }, { key: 'capability', label: '能力标签' },
    { key: 'contactPerson', label: '联系人' }, { key: 'contactPhone', label: '联系电话' },
    { key: 'responsibleName', label: '责任人' }, { key: 'currentIssues', label: '当前重要问题' },
    { key: 'risk', label: '风险' }, { key: 'updatedAt', label: '最近更新' },
    { key: 'lastLoginAt', label: '最后登录' },
    { key: 'status', label: '状态' }, { key: 'actions', label: '操作', required: true },
  ];
  return (
    <Modal title="自定义列表列" open={visible} onCancel={onCancel} onOk={() => onCancel()} width={360}>
      <Checkbox.Group value={selected} onChange={onChange} style={{ width: '100%' }}>
        <Space direction="vertical" style={{ width: '100%' }}>
          {allOptions.map((opt) => <Checkbox key={opt.key} value={opt.key} disabled={opt.required}>{opt.label}{opt.required ? '（不可取消）' : ''}</Checkbox>)}
        </Space>
      </Checkbox.Group>
      <div style={{ marginTop: 16 }}><Button size="small" onClick={() => onChange(DEFAULT_COLUMNS)}>恢复默认</Button></div>
    </Modal>
  );
};

// ══════════════════════════════════════════════
//  子组件：归档 Drawer
// ══════════════════════════════════════════════
const ArchiveDrawer = ({ visible, customers, onClose, onRestore, navigate }) => {
  const [searchName, setSearchName] = useState('');
  const [searchId, setSearchId] = useState('');
  const [appliedSearch, setAppliedSearch] = useState({ name: '', id: '' });

  const archivedCustomers = customers.filter((c) => c.status === 'archived');
  const filteredArchived = useMemo(() => {
    return archivedCustomers.filter((c) => {
      if (appliedSearch.name) {
        const kw = appliedSearch.name.toLowerCase();
        const nameHit = c.enterpriseName.toLowerCase().includes(kw) || (c.aliasName || '').toLowerCase().includes(kw);
        if (!nameHit) return false;
      }
      if (appliedSearch.id && !c.enterpriseId.toLowerCase().includes(appliedSearch.id.toLowerCase())) return false;
      return true;
    });
  }, [archivedCustomers, appliedSearch]);

  const hasArchived = archivedCustomers.length > 0;

  const handleSearch = () => { setAppliedSearch({ name: searchName, id: searchId }); };
  const handleReset = () => { setSearchName(''); setSearchId(''); setAppliedSearch({ name: '', id: '' }); };

  const columns = [
    { title: '企业名称', dataIndex: 'enterpriseName', width: 180, render: (t, r) => <Button type="link" style={{ padding: 0, fontWeight: 500 }} onClick={() => { onClose(); navigate(`/customer/crm/detail/${r.enterpriseId}`); }}>{t}</Button> },
    { title: '企业别名', dataIndex: 'aliasName', width: 120, ellipsis: true, render: (t) => t || '-' },
    { title: '服务内容', dataIndex: ['tags', 'serviceContent'], width: 140, render: (tags) => tags?.length ? <Space size={2}>{tags.slice(0, 2).map((t) => <Tag key={t} color="blue" style={{ border: 'none', margin: 0, fontSize: 11 }}>{t}</Tag>)}{tags.length > 2 && <Tag style={{ border: 'none', margin: 0, fontSize: 11 }}>+{tags.length - 2}</Tag>}</Space> : '-' },
    { title: '责任人', dataIndex: 'responsibleName', width: 80 },
    { title: '归档时间', dataIndex: 'archivedAt', width: 130 },
    { title: '操作', width: 130, render: (_, r) => (
      <Space size={0} split={<span style={{ color: '#e8e8e8' }}>|</span>}>
        <Button type="link" size="small" onClick={() => { onClose(); navigate(`/customer/crm/detail/${r.enterpriseId}`); }}>详情</Button>
        <Button type="link" size="small" icon={<UndoOutlined />} onClick={() => onRestore(r)}>恢复</Button>
      </Space>
    )},
  ];

  return (
    <Drawer title="归档客户" open={visible} onClose={onClose} width={720}>
      {hasArchived ? (
        <>
          <div style={{ marginBottom: 16, display: 'flex', gap: 8 }}>
            <Input placeholder="请输入企业名称或别名" value={searchName} onChange={(e) => setSearchName(e.target.value)} allowClear onPressEnter={handleSearch} style={{ flex: 1 }} />
            <Input placeholder="请输入企业ID" value={searchId} onChange={(e) => setSearchId(e.target.value)} allowClear onPressEnter={handleSearch} style={{ flex: 1 }} />
            <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
            <Button icon={<ReloadOutlined />} onClick={handleReset}>重置</Button>
          </div>
          <Table columns={columns} dataSource={filteredArchived} pagination={false} size="small"
            locale={{ emptyText: (appliedSearch.name || appliedSearch.id) ? '未找到匹配的归档客户' : '暂无归档客户' }} />
        </>
      ) : (
        <div style={{ textAlign: 'center', padding: 60, color: '#999' }}>
          <InboxOutlined style={{ fontSize: 48, color: '#d9d9d9' }} />
          <div style={{ marginTop: 16 }}>暂无归档客户</div>
        </div>
      )}
    </Drawer>
  );
};

// ══════════════════════════════════════════════
//  主组件：CustomerList
// ══════════════════════════════════════════════
const CustomerList = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [customers, setCustomers] = useState(MOCK_CUSTOMERS);
  const [searchFilters, setSearchFilters] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [transferModalVisible, setTransferModalVisible] = useState(false);
  const [columnModalVisible, setColumnModalVisible] = useState(false);
  const [archiveDrawerVisible, setArchiveDrawerVisible] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState(DEFAULT_COLUMNS);

  // 活跃客户
  const activeCustomers = useMemo(() => customers.filter((c) => c.status === 'active'), [customers]);

  const filteredCustomers = useMemo(() => {
    return activeCustomers.filter((c) => {
      if (searchFilters.keyword) {
        const kw = searchFilters.keyword.toLowerCase();
        const nameHit = c.enterpriseName.toLowerCase().includes(kw) || (c.aliasName || '').toLowerCase().includes(kw);
        if (!nameHit) return false;
      }
      if (searchFilters.companyId) {
        const id = searchFilters.companyId.trim().toLowerCase();
        if (!c.enterpriseId.toLowerCase().includes(id)) return false;
      }
      if (searchFilters.responsible && c.responsibleUserId !== searchFilters.responsible) return false;
      if (searchFilters.risk === 'hasRisk' && c.hasRisk !== 1) return false;
      if (searchFilters.risk === 'noRisk' && c.hasRisk === 1) return false;
      // 最后登录时间区间（含快捷选择「N天未登录」）
      if (searchFilters.lastLoginRange && searchFilters.lastLoginRange.length === 2 && searchFilters.lastLoginRange[0] && searchFilters.lastLoginRange[1]) {
        if (!c.lastLoginAt) return false;
        const start = searchFilters.lastLoginRange[0].startOf('day');
        const end = searchFilters.lastLoginRange[1].endOf('day');
        const loginAt = dayjs(c.lastLoginAt);
        if (loginAt.isBefore(start) || loginAt.isAfter(end)) return false;
      }
      // 标签筛选：客户拥有任一选中标签即匹配
      if (searchFilters.serviceTag && searchFilters.serviceTag.length > 0) {
        if (!searchFilters.serviceTag.some((t) => (c.tags?.serviceContent || []).includes(t))) return false;
      }
      if (searchFilters.customerCategory && searchFilters.customerCategory.length > 0) {
        if (!searchFilters.customerCategory.some((t) => (c.tags?.customerCategory || []).includes(t))) return false;
      }
      if (searchFilters.customerTag && searchFilters.customerTag.length > 0) {
        if (!searchFilters.customerTag.some((t) => (c.tags?.customerTag || []).includes(t))) return false;
      }
      return true;
    }).sort((a, b) => {
      if (b.weight !== a.weight) return b.weight - a.weight;
      const aRisk = a.hasRisk === 1 ? 1 : 0;
      const bRisk = b.hasRisk === 1 ? 1 : 0;
      if (bRisk !== aRisk) return bRisk - aRisk;
      return b.updatedAt.localeCompare(a.updatedAt);
    });
  }, [activeCustomers, searchFilters]);

  const handleSearch = (values) => {
    setSearchFilters(values);
  };

  const handleReset = () => {
    form.resetFields();
    setSearchFilters({});
  };

  const handleArchive = (record) => {
    setCustomers((prev) => prev.map((c) => (c.key === record.key ? { ...c, status: 'archived', archivedAt: new Date().toISOString().slice(0, 16).replace('T', ' ') } : c)));
    message.success('已归档，可在「查看归档」中恢复');
  };

  const handleRestore = (record) => {
    setCustomers((prev) => prev.map((c) => (c.key === record.key ? { ...c, status: 'active', archivedAt: '' } : c)));
    message.success('已恢复为活跃客户');
  };

  const handleBatchArchive = () => {
    if (selectedRowKeys.length === 0) { message.warning('请先选择客户'); return; }
    Modal.confirm({
      title: '批量归档', content: `确定将 ${selectedRowKeys.length} 个客户归档？归档后默认列表不显示。`,
      onOk: () => {
        setCustomers((prev) => prev.map((c) => (selectedRowKeys.includes(c.key) ? { ...c, status: 'archived', archivedAt: new Date().toISOString().slice(0, 16).replace('T', ' ') } : c)));
        setSelectedRowKeys([]);
        message.success(`已归档 ${selectedRowKeys.length} 个客户，可在「查看归档」中恢复`);
      },
    });
  };

  const handleBatchTransfer = () => {
    if (selectedRowKeys.length === 0) { message.warning('请先选择客户'); return; }
    setTransferModalVisible(true);
  };

  const handleTransferConfirm = (newUserId) => {
    const newUser = MOCK_INTERNAL_USERS.find((u) => u.userId === newUserId);
    setCustomers((prev) => prev.map((c) => (selectedRowKeys.includes(c.key) ? { ...c, responsibleUserId: newUserId, responsibleName: newUser?.name || '', responsibleAccount: newUser?.account || '' } : c)));
    setTransferModalVisible(false); setSelectedRowKeys([]);
    message.success(`已成功转移 ${selectedRowKeys.length} 个客户`);
  };

  const renderTags = (tags) => {
    if (!tags || tags.length === 0) return <span style={{ color: '#ccc' }}>-</span>;
    const visible = tags.slice(0, 3);
    const hidden = tags.slice(3);
    return <Space size={4} wrap>{visible.map((t) => <Tag key={t} color="blue" style={{ border: 'none', margin: 0 }}>{t}</Tag>)}{hidden.length > 0 && <Tag style={{ border: 'none', margin: 0 }}>+{hidden.length}</Tag>}</Space>;
  };

  const columns = [
    { title: '权重', dataIndex: 'weight', key: 'weight', width: 80, sorter: (a, b) => a.weight - b.weight, defaultSortOrder: 'descend', render: (val) => (
      <Space size={4}><Text strong style={{ fontSize: 14 }}>{val}</Text><div style={{ width: 36, height: 4, borderRadius: 2, background: '#f0f0f0', overflow: 'hidden' }}><div style={{ width: `${val}%`, height: '100%', background: val >= 80 ? '#ff4d4f' : val >= 50 ? '#fa8c16' : '#1677ff', borderRadius: 2 }} /></div></Space>
    )},
    { title: '企业名称', dataIndex: 'enterpriseName', key: 'enterpriseName', width: 200, render: (text, record) => (
      <Space direction="vertical" size={0}><Button type="link" style={{ padding: 0, fontWeight: 500 }} onClick={() => navigate(`/customer/crm/detail/${record.enterpriseId}`)}>{text}</Button><Text type="secondary" style={{ fontSize: 12 }}>{record.enterpriseId}</Text></Space>
    )},
    { title: '企业别名', dataIndex: 'aliasName', key: 'aliasName', width: 140, ellipsis: true, render: (text) => text || '-' },
    { title: '服务内容', dataIndex: ['tags', 'serviceContent'], key: 'serviceContent', width: 160, render: renderTags },
    { title: '客户分类', dataIndex: ['tags', 'customerCategory'], key: 'customerCategory', width: 130, render: renderTags },
    { title: '客户标签', dataIndex: ['tags', 'customerTag'], key: 'customerTag', width: 130, render: renderTags },
    { title: '联系人', dataIndex: 'contactPerson', key: 'contactPerson', width: 90 },
    { title: '联系电话', dataIndex: 'contactPhone', key: 'contactPhone', width: 120 },
    { title: '能力标签', dataIndex: ['tags', 'capability'], key: 'capability', width: 140, render: renderTags },
    { title: '责任人', dataIndex: 'responsibleName', key: 'responsibleName', width: 100, render: (name, record) => (
      <Space direction="vertical" size={0}><Text>{name}</Text><Text type="secondary" style={{ fontSize: 12 }}>{record.responsibleAccount}</Text></Space>
    )},
    { title: '当前问题', dataIndex: 'currentIssues', key: 'currentIssues', width: 180, ellipsis: true, render: (text) => text ? <Tooltip title={text}><Text style={{ maxWidth: 160 }} ellipsis>{text}</Text></Tooltip> : <span style={{ color: '#ccc' }}>-</span> },
    { title: '风险', key: 'risk', width: 60, align: 'center', render: (_, r) => (r.hasRisk === 1 ? <Tooltip title="该客户存在风险"><WarningFilled style={{ color: '#fa8c16', fontSize: 16 }} /></Tooltip> : <span style={{ color: '#ccc' }}>-</span>) },
    { title: '最近更新', dataIndex: 'updatedAt', key: 'updatedAt', width: 130, sorter: (a, b) => a.updatedAt.localeCompare(b.updatedAt), render: (t) => <Text style={{ fontSize: 12 }}>{t}</Text> },
    { title: '最后登录', dataIndex: 'lastLoginAt', key: 'lastLoginAt', width: 150, sorter: (a, b) => (a.lastLoginAt || '').localeCompare(b.lastLoginAt || ''), render: (t) => t ? <Text style={{ fontSize: 12 }}>{t}</Text> : <span style={{ color: '#ccc' }}>从未登录</span> },
    { title: '操作', key: 'actions', width: 100, fixed: 'right', render: (_, r) => (
      <Space size={0} split={<span style={{ color: '#e8e8e8' }}>|</span>}>
        <Button type="link" size="small" onClick={() => navigate(`/customer/crm/detail/${r.enterpriseId}`)}>详情</Button>
        <Button type="link" size="small" onClick={() => handleArchive(r)}>归档</Button>
      </Space>
    )},
  ];

  const filteredColumns = columns.filter((col) => visibleColumns.includes(col.key));
  const riskCount = activeCustomers.filter((c) => c.hasRisk === 1).length;
  const weeklyNewCount = activeCustomers.filter((c) => c.createdAt > '2026-07-16').length;
  const archivedCount = customers.filter((c) => c.status === 'archived').length;

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Title level={4} style={{ margin: 0 }}>客户跟踪</Title>
      </div>

      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={8}><Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)', textAlign: 'center' }}><Text type="secondary">活跃客户</Text><div style={{ fontSize: 32, fontWeight: 600, color: '#1677ff' }}>{activeCustomers.length}</div></Card></Col>
        <Col span={8}><Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)', textAlign: 'center' }}><Text type="secondary">有风险客户</Text><div style={{ fontSize: 32, fontWeight: 600, color: '#fa8c16' }}>{riskCount}</div></Card></Col>
        <Col span={8}><Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)', textAlign: 'center' }}><Text type="secondary">本周新增</Text><div style={{ fontSize: 32, fontWeight: 600, color: '#52c41a' }}>{weeklyNewCount}</div></Card></Col>
      </Row>

      <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)', padding: '16px 4px', marginBottom: 8 }}>
        <Form form={form} layout="inline" onFinish={handleSearch}>
          <Form.Item name="keyword" style={{ marginBottom: 0 }}>
            <Input placeholder="请输入企业名称或别名" allowClear style={{ width: 220 }} />
          </Form.Item>
          <Form.Item name="companyId" style={{ marginBottom: 0 }}>
            <Input placeholder="请输入企业ID" allowClear style={{ width: 200 }} />
          </Form.Item>
          <Form.Item name="responsible" style={{ marginBottom: 0 }}>
            <Select placeholder="责任人" allowClear showSearch optionFilterProp="children" style={{ width: 140 }}>
              {MOCK_INTERNAL_USERS.map((u) => <Option key={u.userId} value={u.userId}>{u.name} / {u.account}</Option>)}
            </Select>
          </Form.Item>
          <Form.Item name="risk" style={{ marginBottom: 0 }}>
            <Select placeholder="风险状态" allowClear style={{ width: 130 }}>
              <Option value="hasRisk">有风险</Option>
              <Option value="noRisk">无风险</Option>
            </Select>
          </Form.Item>
          <Form.Item name="lastLoginRange" style={{ marginBottom: 0 }}>
            <RangePicker placeholder={['最后登录开始', '最后登录结束']} presets={LAST_LOGIN_PRESETS} style={{ width: 300 }} />
          </Form.Item>
          <Form.Item name="serviceTag" style={{ marginBottom: 0 }}>
            <Select mode="multiple" placeholder="服务标签" allowClear maxTagCount={1} style={{ width: 160 }}>
              {TAG_OPTIONS.serviceContent.map((t) => <Option key={t} value={t}>{t}</Option>)}
            </Select>
          </Form.Item>
          <Form.Item name="customerCategory" style={{ marginBottom: 0 }}>
            <Select mode="multiple" placeholder="客户分类" allowClear maxTagCount={1} style={{ width: 160 }}>
              {TAG_OPTIONS.customerCategory.map((t) => <Option key={t} value={t}>{t}</Option>)}
            </Select>
          </Form.Item>
          <Form.Item name="customerTag" style={{ marginBottom: 0 }}>
            <Select mode="multiple" placeholder="客户标签" allowClear maxTagCount={1} style={{ width: 160 }}>
              {TAG_OPTIONS.customerTag.map((t) => <Option key={t} value={t}>{t}</Option>)}
            </Select>
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Space>
              <Button type="primary" htmlType="submit" icon={<SearchOutlined />}>查询</Button>
              <Button icon={<ReloadOutlined />} onClick={handleReset}>重置</Button>
            </Space>
          </Form.Item>
        </Form>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8, padding: '0 4px' }}>
        <Space>
          <Button disabled={selectedRowKeys.length === 0} onClick={handleBatchArchive}>批量归档</Button>
          <Button disabled={selectedRowKeys.length === 0} icon={<SwapOutlined />} onClick={handleBatchTransfer}>指定客服</Button>
        </Space>
        <Space>
          <Button icon={<FolderOpenOutlined />} onClick={() => setArchiveDrawerVisible(true)}>查看归档{archivedCount > 0 && `（${archivedCount}）`}</Button>
          <Button icon={<SettingOutlined />} onClick={() => setColumnModalVisible(true)} />
        </Space>
      </div>

      <Table rowSelection={{ selectedRowKeys, onChange: setSelectedRowKeys }} columns={filteredColumns} dataSource={filteredCustomers}
        pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录`, defaultPageSize: 20 }} scroll={{ x: 1560 }}
        locale={{ emptyText: <div style={{ padding: 40 }}><InboxOutlined style={{ fontSize: 48, color: '#d9d9d9' }} /><div style={{ marginTop: 16, color: '#999' }}>暂无活跃客户</div></div> }}
      />

      <TransferModal visible={transferModalVisible} selectedCount={selectedRowKeys.length} onCancel={() => setTransferModalVisible(false)} onConfirm={handleTransferConfirm} />
      <ColumnSettingsModal visible={columnModalVisible} selected={visibleColumns} onChange={setVisibleColumns} onCancel={() => setColumnModalVisible(false)} />
      <ArchiveDrawer visible={archiveDrawerVisible} customers={customers} onClose={() => setArchiveDrawerVisible(false)} onRestore={handleRestore} navigate={navigate} />
    </div>
  );
};

export default CustomerList;
